import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=b9c11f30&scoped=true&"
import script from "./BaseLayout.vue?vue&type=script&lang=ts&"
export * from "./BaseLayout.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=b9c11f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c11f30",
  null
  
)

export default component.exports